import React, { useState } from "react";

const PRODUCT_URL = "https://meli.la/1SZKfrY";
const PRODUCT_IMAGE_URL =
  "https://http2.mlstatic.com/D_NQ_NP_2X_815827-MLB71634435657_092023-F.webp";

function Obd2ScannerCard() {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <a
      className="obd2-card"
      href={PRODUCT_URL}
      target="_blank"
      rel="noopener noreferrer sponsored"
      aria-label="Ver anúncio do Scanner OBD2 Bluetooth no Mercado Livre"
    >
      <span className="obd2-card__media" aria-hidden="true">
        {imageFailed ? (
          <span className="obd2-card__image-fallback">
            OBD2
          </span>
        ) : (
          <img
            src={PRODUCT_IMAGE_URL}
            alt="Scanner Automotivo OBD2 Bluetooth ELM327 PIC18F25K80"
            width="96"
            height="96"
            loading="lazy"
            decoding="async"
            onError={() => setImageFailed(true)}
          />
        )}
      </span>

      <div className="obd2-card__content">
        <span className="obd2-card__badge">Recomendado para ETACS</span>
        <h2 className="obd2-card__title">Scanner OBD2 Bluetooth</h2>
        <p className="obd2-card__description">
          Compatível com ETACS e diagnóstico via Bluetooth.
        </p>
        <div className="obd2-card__highlights" aria-label="Destaques">
          <span>Placa dupla V1.5</span>
          <span>PIC18F25K80</span>
          <span>iPhone</span>
          <span>Anatel</span>
        </div>
        <div className="obd2-card__footer">
          <span className="obd2-card__price">A partir de R$ 60</span>
          <span className="btn btn-primary btn-sm obd2-card__cta">
            Ver anúncio
          </span>
        </div>
      </div>
    </a>
  );
}

export default Obd2ScannerCard;
